module.exports = __webpack_public_path__ + "static/media/biteship-puzzle-icon.f74d117d.png";